<template>
  <div>
    <el-steps class="warpper" :active="active" align-center>
      <el-step
        v-for="(item, index) in statusList"
        :key="index"
        :title="item.label"
        :class="{ actives: taskData[item.value] }"
        :description="taskData[item.value + '_at'] || '-'"
      >
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  props: {
    taskData: {
      type: Object,
      default: () => null,
    },
    statusList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
      isTaskData: this.taskData,
    };
  },
  mounted() {
    this.computedActive();
  },
  watch: {
    taskData(v) {
      this.isTaskData = v;
    },
  },
  methods: {
    computedActive() {
      this.active =
        this.statusList.findIndex(
          (item, index) => item.value == this.isTaskData.status
        ) + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.warpper {
  display: flex;
  margin-bottom: 20px;
}
/deep/ .el-step.is-center .el-step__description {
  padding-left: 0;
  padding-right: 0;
}
.timeLineItem {
  flex: 1;
  text-align: center;
  height: 120px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 18px;
    display: block;
    // transform: translateY(-50%);
    width: calc(50% - 36px / 2);
    height: 1px;
    background: #000;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    top: 18px;
    // transform: translateY(-50%);
    width: calc(50% - 36px / 2);
    height: 1px;
    background: #000;
  }

  &:first-child::before {
    display: none;
  }

  &:last-child::after {
    display: none;
  }

  &.actives::before {
    background: #409eff;
  }

  &.actives::after {
    background: #409eff;
  }
}

.actives:last-child::after {
  background: #409eff !important;
}

.actives:first-child::after {
  background: #409eff;
}

.timeLineNum {
  display: inline-block;
  margin: 0 auto;
  width: 36px;
  height: 36px;
  border: 2px solid #ccc;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  font-weight: bold;
}
</style>